import PocketBase from 'pocketbase';

const pocketbaseUrl = process.env.REACT_APP_POCKETBASE_URL;

if (!pocketbaseUrl) {
  console.warn('PocketBase URL not found. Please set REACT_APP_POCKETBASE_URL in your .env file.');
}

const pb = new PocketBase(pocketbaseUrl || 'https://api.fotografica.ro');

export default pb;
